import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { MapaOlComponent } from './mapa-ol/mapa-ol.component';
import { MapaRoutingModule } from './mapa.routing.module';
import { CamarasMultipleComponent } from '../../standalone/camaras-multiple/camaras-multiple.component';
import { CardComponent } from '../../../auxiliares/cards/cards.component';
import { ButtonComponent } from '../../../auxiliares/button/button.component';
import { SelectorTipoMapaComponent } from '../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
import { MapaFacilV2Component } from '../../../auxiliares/mapbox/mapa-facil-v2.component';

@NgModule({
  declarations: [MapaOlComponent],
  imports: [
    CommonModule,
    AuxiliaresModule,
    MapaRoutingModule,
    CamarasMultipleComponent,
    CardComponent,
    ButtonComponent,
    SelectorTipoMapaComponent,
    MapaFacilV2Component,
  ],
})
export class MapaModule {}
